export default {
  section: {
    marginBottom: 30,
  },
};
